import React, { useState } from "react";
import FinanceTripsList from "./FinanceTripsList";
import SettlementGuidelines from "./SettlementGuidelines";
import "../../css/Finance/FinanceDashboard.css";

const FinanceDashboard = () => {
  const [activeView, setActiveView] = useState("settlements");

  const headerTitle =
    activeView === "settlements"
      ? "Rozliczenia wycieczek"
        : "Zasady rozliczania";

  return (
    <div className="finance-container">
      <div className="finance-header-row">
        <div className="finance-header">{headerTitle}</div>
      </div>

      <div className="finance-view-tabs">
        <div className={`finance-view-tab ${activeView === "settlements" ? "active" : ""}`} onClick={() => setActiveView("settlements")}>Rozliczenia</div>
        <div className={`finance-view-tab ${activeView === "guidelines" ? "active" : ""}`} onClick={() => setActiveView("guidelines")}>Zasady rozliczania</div>
      </div>

      {activeView === "settlements" && <FinanceTripsList />}
      {activeView === "guidelines" && <SettlementGuidelines />}
    </div>
  );
};

export default FinanceDashboard;
